import React, { useEffect, useRef } from 'react';
import { List, Typography } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { useChat } from '../../context/ChatContext';

const { Text } = Typography;

const MessageList = ({ messages, partnerTyping, socketId }) => {
    const { darkMode } = useChat();
    const listRef = useRef(null);
    const messagesEndRef = useRef(null);

    // Reliable scrolling
    useEffect(() => {
        if (listRef.current) {
            const container = listRef.current;
            container.scrollTop = container.scrollHeight;
        }
    }, [messages]);

    // Smooth scroll for typing only
    useEffect(() => {
        if (partnerTyping) {
            messagesEndRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
    }, [partnerTyping]);

    return (
        <div ref={listRef} style={{ 
            flex: 1, 
            overflowY: 'auto', 
            padding: '10px 5px',
            display: 'flex',
            flexDirection: 'column',
            scrollBehavior: 'auto'
        }}>
            <List
                dataSource={messages}
                style={{ width: '100%' }}
                renderItem={(msg) => {
                    if (msg.type === 'system') {
                        return (
                            <div style={{ textAlign: 'center', margin: '15px 0' }}>
                                <Text type="secondary" style={{ fontSize: '12px', background: darkMode ? '#333' : '#f0f0f0', padding: '4px 12px', borderRadius: '10px' }}>
                                    {msg.text}
                                </Text>
                            </div>
                        );
                    }

                    const isOwn = msg.from === socketId || msg.type === 'own';
                    
                    return (
                        <List.Item style={{ 
                            border: 'none', 
                            justifyContent: isOwn ? 'flex-end' : 'flex-start',
                            padding: '2px 0'
                        }}>
                            <div style={{ 
                                display: 'flex', 
                                flexDirection: 'column', 
                                alignItems: isOwn ? 'flex-end' : 'flex-start',
                                maxWidth: '85%'
                            }}>
                                <div style={{ 
                                    padding: '8px 12px', 
                                    borderRadius: '18px',
                                    borderBottomRightRadius: isOwn ? '4px' : '18px',
                                    borderBottomLeftRadius: !isOwn ? '4px' : '18px',
                                    background: isOwn ? '#1677ff' : (darkMode ? '#333' : '#f0f2f5'),
                                    color: isOwn ? 'white' : (darkMode ? '#fff' : 'black'),
                                    fontSize: '15px',
                                    lineHeight: '1.4',
                                    wordBreak: 'break-word',
                                    boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                                }}>
                                    {msg.text}
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 2, padding: '0 4px' }}>
                                    <Text type="secondary" style={{ fontSize: '10px' }}>{msg.timestamp}</Text>
                                    {isOwn && msg.read && (
                                        <CheckOutlined style={{ fontSize: '10px', color: '#52c41a' }} />
                                    )}
                                </div>
                            </div>
                        </List.Item>
                    );
                }}
            />
            {partnerTyping && (
                <div style={{ padding: '5px 10px' }}>
                    <Text type="secondary" italic style={{ fontSize: '12px', opacity: 0.7 }}>Անծանոթը գրում է...</Text>
                </div>
            )}
            <div ref={messagesEndRef} style={{ float: 'left', clear: 'both', height: 1 }} />
        </div>
    );
};

export default MessageList;